import { defaults, omit } from 'lodash';
import { FINISH_SERVER_SIDE_RENDERING, INITIAL_RENDER, LOGOUT } from '../constants/actions';
import { GET_USER } from '../constants/requests';
import { getServerSideEncodedGuidZuid } from '../../server/utils/getServerSideEncodedGuidZuid';

const initState = {
  originalServerSideRequestCookies: {},
  ip: '',
  loggedIn: false,
  userToken: '',
  email: '',
  hasStrongAuthentication: false,
  roles: [],
  isPostingPathAdmin: false,
  features: {
    canAccessAnalytics: false,
    canAccessBilling: false,
    canAccessContacts: false,
    canAccessMainAccountSettings: false,
    canAccessMainAnalytics: false,
    canAccessMainContactSupport: false,
    canAccessMainContacts: false,
    canAccessMainHelp: false,
    canAccessMainLeadManagement: false,
    canAccessMainMaintenanceTracker: false,
    canAccessMainMessages: false,
    canAccessMainMyProperties: false,
    canAccessMainNotificationCenter: false,
    canAccessMainPayments: false,
    canAccessMainResources: false,
    canAccessMainSecuritySettings: false,
    canAccessMessages: false,
    canAccessMultiFamilyResources: false,
    canAccessUserManagement: false,
    canAddListing: false,
    canRespondToReview: false,
    canUpdateListing: false,
    canViewOnboardingFlow: false,
  },
  hasSeenNewPaymentsPage: false,
  applicationsEnabled: false,
  summary: {},
  isMultifamilyCustomer: false,
  isRocketshipCustomerOnly: false,
  canAccessMainAnalytics: false,
  isSingleFamilyEnterpriseCustomer: false,
  paymentsAcceptedCount: 0,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case INITIAL_RENDER: {
      const { ip, originalServerSideRequestCookies } = action;
      return {
        ...state,
        ip,
        originalServerSideRequestCookies,
      };
    }
    case FINISH_SERVER_SIDE_RENDERING: {
      return {
        ...state,
        // We want to prevent sending httpOnly cookies to malicious actors in the browser
        // Once SSR is completed, we can remove these cookies from state
        originalServerSideRequestCookies: {},
      };
    }
    case GET_USER.RECEIVE: {
      const defaultedState = defaults({}, action.response.data.response, initState);
      const {
        loggedIn,
        userToken,
        email,
        hasStrongAuthentication,
        roles,
        isPostingPathAdmin,
        features,
        impersonatorEmail,
        impersonatorUserToken,
        applicationsEnabled,
        summary,
        isMultifamilyCustomer,
        isRocketshipCustomerOnly,
        canAccessMainAnalytics,
        firstName,
        lastName,
        isSingleFamilyEnterpriseCustomer,
        isEnterpriseCustomer,
      } = defaultedState;
      const { originalServerSideRequestCookies: { zguid = '' } = {} } = state;

      const encodedGuidZuid = getServerSideEncodedGuidZuid(zguid, userToken);

      return {
        ...state,
        loggedIn,
        userToken,
        encodedGuidZuid,
        email,
        hasStrongAuthentication,
        roles,
        isPostingPathAdmin,
        features,
        impersonatorEmail,
        impersonatorUserToken,
        applicationsEnabled,
        summary,
        isMultifamilyCustomer,
        isRocketshipCustomerOnly,
        canAccessMainAnalytics,
        ireneFirstName: firstName,
        ireneLastName: lastName,
        isSingleFamilyEnterpriseCustomer,
        isEnterpriseCustomer,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        ...omit(initState, ['originalServerSideRequestCookies', 'ip']),
      };
    }
    default: {
      return state;
    }
  }
}
